import { useTranslation } from 'react-i18next';
import StageAccordion from './CardElements/StageAccordion';
import { permissionObj } from '../../Helpers/permission';
import Subtitle from '../../components/Header/Subtitle';
import { CustomTextField } from '../../components/CustomTextField';
import ButtonAction from '../../components/buttons/ButtonAction';
import TemplateDragButtons from './Subcomponents/TemplateDragButtons';
import AttributesList from './Subcomponents/AttributesList';
import ShapeProperties from './Subcomponents/ShapesProperties';
import CanvasFrontAndBack from './Subcomponents/CanvasFrontAngBack';
import AlignmentText from './Subcomponents/AlingmentText';
import CanvasControl from './Subcomponents/CanvasControl';
import ShapeColorPicker from './Subcomponents/ShapeColorPicker';
import routes from '../../Routes/routes';
import FunctionalityCreateTemplate from './Functionality/CreateTemplate';
import { useSelector } from 'react-redux';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const CreateTemplate = () => {
    const { t, i18n } = useTranslation();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {
        templateName,
        setTemplateName,
        showResources,
        resourcesList,
        handleDragStart,
        selectedShape,
        shapeHeight,
        shapeWidth,
        shapeHorizontal,
        shapeVertical,
        shapeCornerRadius,
        shapeRadius,
        shapeStrokeWidth,
        fontSize,
        handleChangeProperty,
        setStageProperties,
        currentStage,
        setSelectedShape,
        isEdit,
        handleEdit,
        handleCreate,
        setCurrentStage,
        cardWidth,
        cardHeight,
        stageProperties,
        stageWidth,
        stageHeight,
        handleShapeClick,
        setShapeHeight,
        setShapeWidth,
        setShapeRadius,
        setFontSize,
        cardBackgroundColor,
        stageFront,
        stageBack,
        setShowResources,
        setShapeVertical,
        updateForm,
        setShapeHorizontal,
        expanded,
        setExpanded,
        emptyFields,
        disabled,
    } = FunctionalityCreateTemplate({});
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    return (
        <>
            <section className='row create-template overflow-y-auto vh-100'>
                <div className='col-3 my-3 d-flex flex-column justify-content-between'>
                    <div>
                        <div className=' m-0'>
                            <Subtitle name={'template'} onBack={routes.cardDesigner.list}/>
                        </div>

                        <div className='overflow-auto-template'>
                            <Subtitle name={'properties'}/>
                            <CustomTextField
                                id='btn_ct_templateName'
                                name='templateName'
                                value={templateName}
                                onChange={(e) => setTemplateName(e.target.value)}
                                trans='name'
                                length={30}
                                showCounter={!disabled}
                                inputProps={{ maxLength: 30 }}
                                required={true}
                                disabled={disabled}
                                error={emptyFields && templateName === ''}
                                emptyFields={emptyFields && templateName === ''}
                            />

                            {!disabled && showResources && (
                                <div className='mt-3'>
                                    <Subtitle name={'resources'}></Subtitle>

                                    <div className='row g-2'>
                                        {resourcesList.map((image, index) => (
                                            <div key={index} className='col-6 col-md-6'>
                                                <img
                                                    src={image.src}
                                                    alt=''
                                                    className='w-100'
                                                    onDragStart={(e) =>
                                                        handleDragStart(e, 'imageTemplate', image.src, image.id)
                                                    }
                                                    data-transfer-type='imageTemplate'
                                                    data-button-type='imageTemplate'
                                                    data-base={image.src}
                                                    data-resource={image.id}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {!disabled && (
                            <>
                            <ShapeProperties
                                selectedShape={selectedShape}
                                shapeHeight={shapeHeight}
                                shapeWidth={shapeWidth}
                                shapeHorizontal={shapeHorizontal}
                                shapeVertical={shapeVertical}
                                shapeCornerRadius={shapeCornerRadius}
                                shapeRadius={shapeRadius}
                                shapeStrokeWidth={shapeStrokeWidth}
                                fontSize={fontSize}
                                handleChangeProperty={handleChangeProperty}
                                t={t}
                            />

                            <AlignmentText selectedShape={selectedShape} handleChangeProperty={handleChangeProperty} />
                            <ShapeColorPicker
                                selectedShape={selectedShape}
                                t={t}
                                setStageProperties={setStageProperties}
                                currentStage={currentStage}
                                setSelectedShape={setSelectedShape}
                            />
                            </>
                            )}
                        </div>
                        <div className='mr-3'>
                            {disabled ? null : isEdit ? (
                                <span>
                                    {(DEV || permission?.includes(permissionObj?.WEB_CARD_DESIGNER_UPDATE)) && (
                                        <ButtonAction
                                            id='btn_ct_update'
                                            name='update'
                                            className='btn-icon-add w-100'
                                            onClick={handleEdit}
                                        />
                                    )}
                                </span>
                            ) : (
                                <ButtonAction
                                    id='btn_ct_create'
                                    name='create'
                                    className='btn-icon-add w-100'
                                    onClick={() => {
                                        handleCreate();
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div className={`${disabled ? 'col-9' : 'col-5'} my-3 content-canvas `}>
                    <CanvasControl
                        setCurrentStage={setCurrentStage}
                        currentStage={currentStage}
                        cardWidth={cardWidth}
                        cardHeight={cardHeight}
                        setStageProperties={setStageProperties}
                        disabled={disabled}
                    />
                    <p className='text-center'>{currentStage === 1 ? t('front_card') : t('back_card')}</p>
                    <CanvasFrontAndBack
                        currentStage={currentStage}
                        stageProperties={stageProperties}
                        stageWidth={stageWidth}
                        stageHeight={stageHeight}
                        selectedShape={selectedShape}
                        handleShapeClick={handleShapeClick}
                        setStageProperties={setStageProperties}
                        setShapeHeight={setShapeHeight}
                        setShapeWidth={setShapeWidth}
                        setShapeRadius={setShapeRadius}
                        setFontSize={setFontSize}
                        fontSize={fontSize}
                        cardBackgroundColor={cardBackgroundColor}
                        stageFront={stageFront}
                        stageBack={stageBack}
                        setShowResources={setShowResources}
                        setShapeVertical={setShapeVertical}
                        updateForm={updateForm}
                        setSelectedShape={setSelectedShape}
                        setShapeHorizontal={setShapeHorizontal}
                        disabled={disabled}
                    />
                </div>
                {!disabled && (
                <div className='col-4 my-3 d-flex'>
                    <TemplateDragButtons handleDragStart={handleDragStart} setShowResources={setShowResources} />
                    <div className='w-100 d-flex flex-column justify-content-between'>
                        <div>
                            <Subtitle name={'layers'}></Subtitle>
                            <div className='mt-3 '>
                                {currentStage === 1 ? (
                                    <StageAccordion
                                        stageIndex={1}
                                        stageProperties={stageProperties}
                                        setStageProperties={setStageProperties}
                                        expanded={expanded}
                                        setExpanded={setExpanded}
                                        currentStage={currentStage}
                                        setSelectedShape={setSelectedShape}
                                        selectedShape={selectedShape}
                                        setShowResources={setShowResources}
                                        updateForm={updateForm}
                                        className='step-container-w'
                                    />
                                ) : (
                                    <StageAccordion
                                        stageIndex={2}
                                        stageProperties={stageProperties}
                                        setStageProperties={setStageProperties}
                                        expanded={expanded}
                                        setExpanded={setExpanded}
                                        currentStage={currentStage}
                                        setSelectedShape={setSelectedShape}
                                        selectedShape={selectedShape}
                                        setShowResources={setShowResources}
                                        updateForm={updateForm}
                                        className='step-container-w'
                                    />
                                )}
                            </div>
                        </div>
                        <AttributesList handleDragStart={handleDragStart} t={t} />
                    </div>
                </div>
                )}
            </section>
        </>
    );
};
